/**
 * Jurisdiction display configuration for the By Jurisdiction cards.
 *
 * Single source of truth: both DashboardPage (entities aggregate) and
 * GroupJurisdictionTab import from here. Adding an entity type to a
 * jurisdiction means editing this file only.
 */

export const JURISDICTION_CONFIG = {
  UK: {
    name: 'United Kingdom',
    flag: '\uD83C\uDDEC\uD83C\uDDE7',
    currency: 'GBP',
    color: '#2563EB',
    country: 'UK',
    entityTypes: ['br_ltd', 'hsr', 'bi_ltd', 'bi_uk', 'bh', 'eci'],
    taxRegime: 'HMRC \u00b7 VAT 20% \u00b7 Corp Tax 25%',
  },
  France: {
    name: 'France',
    flag: '\uD83C\uDDEB\uD83C\uDDF7',
    currency: 'EUR',
    color: '#DC2626',
    country: 'France',
    entityTypes: ['afpv', 'bi_immo', 'sci_113', 'pfv', 'bi_sas'],
    taxRegime: 'DGFiP \u00b7 TVA 20% \u00b7 IS 25%',
  },
  Personal: {
    name: 'Personal',
    flag: '\uD83D\uDC64',
    // Personal is reported in EUR (the joint entity's own currency); the live
    // rate converter handles the GBP->EUR sub-balances so the total stays exact.
    currency: 'EUR',
    color: '#F59E0B',
    country: 'UK/France',
    entityTypes: ['fan_zhang', 'fan_zhang_piotr_kacki', 'piotr_kacki'],
    taxRegime: 'Self Assessment \u00b7 UK & France',
  },
};

// Maps the backend predicate bucket (services/bank_balance_positions.py
// account_jurisdiction, returned per account on /bank-balances/summary as
// `jurisdiction`) to the card config key above. The cards bucket STRICTLY by
// this; anything not mapped here (i.e. "unassigned", or an unknown value) falls
// to the Unassigned card. Keep in sync with account_jurisdiction's return
// values (UK / FR / personal / unassigned).
export const PREDICATE_BUCKET_TO_CONFIG = {
  UK: 'UK',
  FR: 'France',
  personal: 'Personal',
};
